export const en = {
    caption: '{format} {width}x{height} м',
    'caption-duration': '{duration} sec',
    'caption-format': '{format} {width}×{height} m',
    'caption-resolution': '{width}×{height} px',
    format: '{format} ({width}×{height}, {duration} sec)'
};
